import { render, staticRenderFns } from "./centralPlate.vue?vue&type=template&id=4c2a1e18&"
import script from "./centralPlate.vue?vue&type=script&lang=js&"
export * from "./centralPlate.vue?vue&type=script&lang=js&"
import style0 from "./centralPlate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2a1e18')) {
      api.createRecord('4c2a1e18', component.options)
    } else {
      api.reload('4c2a1e18', component.options)
    }
    module.hot.accept("./centralPlate.vue?vue&type=template&id=4c2a1e18&", function () {
      api.rerender('4c2a1e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ota/firmware/centralPlate.vue"
export default component.exports